import React, { useState } from "react";
import { FaLinkedin, FaGithub, FaInstagram, FaTwitter, FaFacebook } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });

      // Hide success message after 5 seconds
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
    }, 1500);
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Get in <span className="gradient-text">Touch</span>
          </h1>
          <p className="hero-subtitle">
            We're excited to hear from you! Reach out for any queries, support, or
            collaboration opportunities.
          </p>
          <div className="hero-badges">
            <div className="badge-item">
              <BiSupport />
              <span>24/7 Support</span>
            </div>
            <div className="badge-item">
              <MdAccessTime />
              <span>Quick Response</span>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-container">
        {/* Contact Info Cards */}
        <div className="contact-info-section">
          <h2 className="section-title">
            <MdEmail />
            Contact Information
          </h2>
          <div className="info-cards">
            {/* Email Card */}
            <div className="info-card">
              <div className="info-icon email-icon">
                <MdEmail />
              </div>
              <h3>Email Us</h3>
              <p>support@arbazaar.com</p>
              <p>info@arbazaar.com</p>
              <a href="mailto:support@arbazaar.com" className="info-link">
                Send Email <i className="fas fa-arrow-right"></i>
              </a>
            </div>

            {/* Phone Card */}
            <div className="info-card">
              <div className="info-icon phone-icon">
                <MdPhone />
              </div>
              <h3>Call Us</h3>
              <p>+91 123-456-7890</p>
              <p>Mon-Fri: 9AM - 6PM IST</p>
              <a href="tel:+911234567890" className="info-link">
                Call Now <i className="fas fa-arrow-right"></i>
              </a>
            </div>

            {/* Location Card */}
            <div className="info-card">
              <div className="info-icon location-icon">
                <MdLocationOn />
              </div>
              <h3>Visit Us</h3>
              <p>AR-Bazaar HQ</p>
              <p>Patna, Bihar, India</p>
              <a href="#map" className="info-link">
                Get Directions <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="contact-content-grid">
          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <div className="form-header">
              <h2>
                <i className="fas fa-paper-plane"></i>
                Send Us a Message
              </h2>
              <p>Fill out the form below and we'll get back to you within 24 hours</p>
            </div>

            {submitSuccess && (
              <div className="success-message">
                <i className="fas fa-check-circle"></i>
                <div>
                  <h4>Message Sent Successfully!</h4>
                  <p>We'll get back to you shortly.</p>
                </div>
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">
                    <i className="fas fa-user"></i>
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">
                    <i className="fas fa-envelope"></i>
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="john@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">
                    <i className="fas fa-phone"></i>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="+91 1234567890"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">
                    <i className="fas fa-tag"></i>
                    Subject
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="sales">Sales & Partnership</option>
                    <option value="feedback">Feedback</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  <i className="fas fa-comment"></i>
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Tell us more about your inquiry..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                <i className="fas fa-paper-plane"></i>
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Sidebar */}
          <div className="contact-sidebar">
            {/* Connect With Us */}
            <div className="sidebar-card">
              <h3>
                <i className="fas fa-share-alt"></i>
                Connect With Us
              </h3>
              <p>Follow us on social media for updates and news</p>
              <div className="social-links">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                  <FaLinkedin />
                  <span>LinkedIn</span>
                </a>
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link github">
                  <FaGithub />
                  <span>GitHub</span>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link twitter">
                  <FaTwitter />
                  <span>Twitter</span>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                  <FaFacebook />
                  <span>Facebook</span>
                </a>
              </div>
            </div>

            {/* Quick Help */}
            <div className="sidebar-card">
              <h3>
                <i className="fas fa-question-circle"></i>
                Quick Help
              </h3>
              <ul className="faq-links">
                <li>
                  <a href="/faq">
                    <i className="fas fa-chevron-right"></i>
                    Frequently Asked Questions
                  </a>
                </li>
                <li>
                  <a href="/shipping">
                    <i className="fas fa-chevron-right"></i>
                    Shipping Information
                  </a>
                </li>
                <li>
                  <a href="/returns">
                    <i className="fas fa-chevron-right"></i>
                    Returns & Refunds
                  </a>
                </li>
                <li>
                  <a href="/privacy">
                    <i className="fas fa-chevron-right"></i>
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            {/* Business Hours */}
            <div className="sidebar-card">
              <h3>
                <MdAccessTime />
                Business Hours
              </h3>
              <div className="hours-list">
                <div className="hours-item">
                  <span className="day">Monday - Friday</span>
                  <span className="time">9:00 AM - 6:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Saturday</span>
                  <span className="time">10:00 AM - 4:00 PM</span>
                </div>
                <div className="hours-item">
                  <span className="day">Sunday</span>
                  <span className="time">Closed</span>
                </div>
              </div>
              <p className="hours-note">
                <i className="fas fa-info-circle"></i>
                All times are in IST (Indian Standard Time)
              </p>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="map-section">
          <h2 className="section-title">
            <MdLocationOn />
            Find Us Here
          </h2>
          <div className="map-wrapper">
            <iframe
              title="AR-Bazaar Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.4856725087254!2d85.13191631501436!3d25.594095783727663!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed58dce6732867%3A0x4059f39a1ac82f06!2sPatna%2C%20Bihar!5e0!3m2!1sen!2sin!4v1629876543210!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
